export default "__VITE_ASSET__Dt6mCCu4__"